<template>
  <advance> </advance>
</template>

<script>
import advance from '../modules/index'
export default {
  components: { advance },
  props: {},
  data() {
    return {}
  },
  created() {},
  mounted() {},
  watch: {},
  computed: {},
  methods: {},
}
</script>

<style scoped></style>
